<svelte:options tag={null}/>
<script lang="typescript">
  import { get_current_component } from "svelte/internal";
  import type { OmPlayerLimits, Sport } from "../types/SportLimit.types";

  export let limits: OmPlayerLimits;
  export let sports: Sport[];
  export let isloading: boolean = false;
  export let error: string = null;
  export let isedit = false;
  export let loadingsports = [];
  let carouselItem;
  let formLimits: OmPlayerLimits;
  let tabs = ['General', 'Sports'];
  let currentTab = tabs[0];
  let sportsLimts;
  let carousel;

  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleTab = (e) => {
    e = e || window.event;
    let target = e.target || e.srcElement;
    let text = target.textContent || target.innerText;
    currentTab = text;

    return currentTab;
  };

  const scrollLeft = () => {
    if (carousel.scrollLeft === 0) return;
    carousel.scrollLeft -= carouselItem + (carousel.children.length * 10);
  };

  const scrollRight = () => {
    carousel.scrollLeft += carouselItem;
  };

  const getSportName = (sportId: number) => sports.find(sport => sport.id === sportId).name;

  const setFormLimits = (limits:OmPlayerLimits) => {formLimits = JSON.parse(JSON.stringify(limits))}

  const handleSportDelete = (sportId: string) => {
    for(let [key, value] of Object.entries(formLimits.sportsLimits)) {
      formLimits.sportsLimits[key][sportId] = null;
    }
    dispatchWcEvent('edit', { form: formLimits, sportLimit: sportId });
  }

  const checkLoadingLimit = (str: string, arr: Array<string>) => arr.includes(str);

  $: limits && isedit && setFormLimits({...limits});

  $: if (limits) {
    limits.sportsLimits ?
      sportsLimts = Object.keys(limits.sportsLimits.liabilityBySportId)?.length :
      sportsLimts = 0
    ;
  };
</script>


<div class="tabbed">
  <header class="tabbed__header">
    <ul class="tabbed__tabs">
      {#each tabs as tab}
        <li class="tabbed__tab">
          <a 
            href="/"
            on:click|preventDefault={(e) => handleTab(e)}
            class="tabbed__link"
            class:active={currentTab === tab}
          >
            {tab}
          </a>
        </li>
      {/each}
    </ul>
  </header>

  <!-- General Limits -->
  <div class="tabbed__content" class:active={currentTab === tabs[0]}>
    {#if limits}
      <div class="activeLimit">
        <ul class="activeLimit__list">
          {#if Object.keys(limits).length === 0}
            <li class="activeLimit__limit">
              <p>No active sports limits</p>
            </li>
          {:else}
            <li class="activeLimit__limit">
              <h4>Liability Limit</h4>
              {limits?.liability ?? "0"}
              <span>&#37;</span>
            </li>
            <li class="activeLimit__limit">
              <h4>Max Stake Limit</h4>
              {limits?.maxStake ?? "0"}
              <span>&#37;</span>
            </li>

            <li class="activeLimit__limit">
              <h4>Live Pending Time</h4>
              {limits?.livePendingTime ?? "0"}
              <span>sec</span>
            </li>

            <li class="activeLimit__limit">
              <h4>PreLive Pending Time</h4>
              {limits?.preLivePendingTime ?? "0"}
              <span>sec</span>
            </li>

            <li class="activeLimit__limit">
              <h4>Suspend Cashout</h4>
              {limits?.suspendCashout ?? "UNSET"}
            </li>
          {/if}
        </ul>
      </div>
    {/if}
  </div>

  <!-- Sports Limits -->
  <div class="tabbed__content" class:active={currentTab === tabs[1]}>
    {#if limits && limits.sportsLimits}
      <div class="activeLimit sports scrollable">
        <!-- Carousel scroll left -->
        {#if sportsLimts >= 2}
          <div class="scrollable-left-arrow" on:click="{() => scrollLeft()}">
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"></path>
            </svg>
          </div>
        {/if}
        <!-- Carousell container -->
        <ul 
          class="activeLimit__list scrollable__list" 
          bind:this="{carousel}"
        >
          {#each Object.entries(limits.sportsLimits.liabilityBySportId) as [key, value]}
            <li class="activeLimit__limit scrollable__item" bind:clientWidth={carouselItem}>
              <header class="activeLimit__header">
                <!-- Delete Button -->
                {#if isedit}
                  <button
                    class="activeLimit__delete"
                    on:click={() => handleSportDelete(key)}
                  >
                    {#if checkLoadingLimit(key, loadingsports)}
                      <div class="sk-chase">
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                      </div>
                    {:else}
                      <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                      </svg>
                    {/if}
                  </button>
                {/if}
                <!-- Title -->
                <h3 class="activeLimit__title">
                  {getSportName(parseInt(key))}
                </h3>
              </header>
              <div class="activeLimit__content">
                <p>
                  Liability Limit:
                  <span>{value} &#37;</span>
                </p>
                <p>
                  Max Stake Limit: 
                  <span>{limits.sportsLimits.maxStakeBySportId[key]} &#37;</span>                  
                </p>
                <p>
                  Live Pending Time:
                  <span>{limits.sportsLimits.livePendingTimeBySportId[key]} sec</span>
                </p>
                <p>
                  PreLive Pending Time:
                  <span>{limits.sportsLimits.preLivePendingTimeBySportId[key]} sec</span>
                </p>
              </div>
            </li>
          {/each}
        </ul>
        <!-- Carousel Scroll right -->
        {#if sportsLimts >= 2}
          <div class="scrollable-right-arrow" on:click="{() => scrollRight()}">
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"></path>
            </svg>
          </div>
        {/if}
      </div>
    {:else}
      <p style="margin-bottom: 15px;">
        No sports limit set
      </p>
    {/if}
  </div>
</div>


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }

  .scrollable {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;

    &__list {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      max-width: 260px;
      width: 100%;
      margin: 0 5px;
      overflow-x: scroll;
      list-style-type: none;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      } /* Chrome */
      scroll-behavior: smooth;
    }

    &__item {
      display: flex;
      min-width: 100%;
      margin-right: 10px;
      transition: all 150ms ease-in-out;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .scrollable-left-arrow,
  .scrollable-right-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 30px 5px;
    max-width: 60px;
    @media (min-width: 1024px) { height: 43px; }

    svg {
      width: 100%;
      max-width: 50px;
      @media (min-width: 580px) { max-width: 25px; }
    }

    &:hover {
      cursor: pointer;
    }
  }


  .tabbed {
    &__header {
      display: flex;
      margin-bottom: 10px;
    }

    &__tabs { display: inline-flex; }

    &__tab {
      margin-right: 20px;
      &:last-child { margin-right: 0; }
    }

    &__link {
      display: flex;
      padding: 10px 0 10px 0;
      background: #fff;
      color: #000;
      &.active {
        color: #307fe2;
        border-bottom: 2px solid #307fe2;
      }
    }

    &__content {
      display: none;
      flex-direction: column;
      color: #000;
      &.active { display: flex; }
    }
  }

  .activeLimit {

    &__list {
      margin-bottom: 15px;
    }

    &__title {
      margin-left: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    &__limit {
      display: flex;
      align-items: flex-start;
      margin-bottom: 5px;
      &:last-child { margin-bottom: 0; }

      h4 { margin-right: 10px; }

      strong {
        font-size: 12px;
      }
    }

    &.sports &__limit { flex-direction: column; }
    &.sports &__title { margin-left: 0; }
    &.sports &__delete { margin-right: 10px; }

    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    &__content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
      font-size: 14px;

      p { 
        margin-bottom: 10px;
        font-weight: bold; 
        &:last-child { margin-bottom: 0; }
      }
      span {  
        margin-left: 10px; 
        font-weight: 400; 
      }
    }

    &__delete {
      width: 25px;
      height: 25px;
      padding: 5px;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      svg { fill: #868686; }
      &:hover {
        svg { fill: #ec7777; }
      }
    }
  }

  .sk-chase {
    width: 10px;
    height: 10px;
    position: relative;
    left: 2px;
    top: 2px;
    animation: sk-chase 2.5s infinite linear both;
  }

  .sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: sk-chase-dot 2.0s infinite ease-in-out both;
  }

  .sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: green;
    border-radius: 100%;
    animation: sk-chase-dot-before 2.0s infinite ease-in-out both;
  }

  .sk-chase-dot:nth-child(1) { animation-delay: -1.1s; }
  .sk-chase-dot:nth-child(2) { animation-delay: -1.0s; }
  .sk-chase-dot:nth-child(3) { animation-delay: -0.9s; }
  .sk-chase-dot:nth-child(4) { animation-delay: -0.8s; }
  .sk-chase-dot:nth-child(5) { animation-delay: -0.7s; }
  .sk-chase-dot:nth-child(6) { animation-delay: -0.6s; }
  .sk-chase-dot:nth-child(1):before { animation-delay: -1.1s; }
  .sk-chase-dot:nth-child(2):before { animation-delay: -1.0s; }
  .sk-chase-dot:nth-child(3):before { animation-delay: -0.9s; }
  .sk-chase-dot:nth-child(4):before { animation-delay: -0.8s; }
  .sk-chase-dot:nth-child(5):before { animation-delay: -0.7s; }
  .sk-chase-dot:nth-child(6):before { animation-delay: -0.6s; }

  @keyframes sk-chase {
    100% { transform: rotate(360deg); }
  }

  @keyframes sk-chase-dot {
    80%, 100% { transform: rotate(360deg); }
  }

  @keyframes sk-chase-dot-before {
    50% {
      transform: scale(0.4);
    } 100%, 0% {
      transform: scale(1.0);
    }
  }
</style>
